import { StateType } from '../../general';

export interface ContentListModel {
  name: string;
  value: string | number;
  state?: StateType;
}